import { forOwn } from 'lodash';

export default class Util {
    constructor(GB, settings) {
        Object.assign(this, {settings});
        this.gb = GB;
        this.isIframe = window.location !== window.parent.location;
        this.isLocalStorageAvailable = this.checkIfLocalStorageAvailable() === "available";
    }

    toQueryString(obj) {
        let returnStr = "";
        forOwn(obj, (value, key) => {
            if (Array.isArray(value)) {
                value.forEach((v) => {
                    returnStr += `&${encodeURIComponent(key)}=${encodeURIComponent(v)}`;
                });
            } else {
                returnStr += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
        });
        return "?" + returnStr.substring(1);
    }

    getQueryParams() {
        let queryParams = {};
        // if (this.isIframe === true || this.settings.allowQueryParams === true) {
            let qp = window.location.search;
            if (qp.substr(0, 1) === "?") {
                qp = qp.substr(1).split("&");

                qp.forEach((param) => {
                    param = param.split("=");
                    queryParams[param[0]] = param[1];
                });
            }
        // }
        return queryParams;
    }

    getQueryParamsFullUrl(query) {
        let hashes = query && query.indexOf('?') > -1 ? query.slice(query.indexOf('?') + 1).split('&') : false;

        return hashes && hashes.reduce((params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {})
    };

    loadJS(arrJs) {
        let promises = [];
        arrJs.forEach((js) => {
            promises.push((function(js) {
                return new Promise((resolve) => {
                    let script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = js;
                    script.onload = () => {
                        resolve(true);
                    };
                    document.body.append(script);
                });
            })(js));
        });
        return Promise.all(promises);
    }

    loadCSS(arrCSS) {
        let promises = [];
        arrCSS.forEach((css) => {
            promises.push((function(css) {
                return new Promise((resolve) => {
                    let style = document.createElement("link");
                    style.type = "text/css";
                    style.rel = "stylesheet";
                    style.href = css;
                    style.onload = () => {
                        resolve(true);
                    };
                    document.body.append(style);
                });
            })(css));
        });
        return Promise.all(promises);
    }

    async loadGameBridgeCSS () {
        if(this.gb.cssLoaded) {
            return;
        }
        try {
            var scripts = document.getElementsByTagName('script');
            let gbCss;
            for (let index = 0; index < scripts.length; index++) {
                const script = scripts[index];
                if(script.src.indexOf("GameBridge")!==-1) {
                    gbCss = script.src.replace("GameBridge.js", "GameBridge.css");
                }
            }
            if (gbCss) {
                await this.loadCSS([gbCss]);
                this.gb.cssLoaded = true;
            }
        } catch (error) {
            console.log("Error loading css: ", error);
        }

    }

    createUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    checkIfLocalStorageAvailable() {
        let test = "test";
        try {
            // try setting an item
            localStorage.setItem("test", test);
            localStorage.removeItem("test");
        }


        catch(e)
        {
            // browser specific checks if local storage was exceeded
            if (e.name === "QUATA_EXCEEDED_ERR" // Chrome
                || e.name === "NS_ERROR_DOM_QUATA_REACHED" //Firefox/Safari
            ) {
                // local storage is full
                return "full";
            } else {
                try{
                    if(localStorage.remainingSpace === 0) {// IE
                        // local storage is full
                        return "full";
                    }
                }catch (e) {
                    // localStorage.remainingSpace doesn't exist
                }

                // local storage might not be available
                return "unavailable";
            }
        }
        if (this.settings.nativeMobileApp) {
            return "unavailable"
        }

        return "available";
    }

    goToFullScreenAutomatic() {
        const fullScreenElement = document.createElement("div");
        fullScreenElement.setAttribute('id', 'full-screen-trigger');
        fullScreenElement.style = "position:fixed;top: 0;left:0;height:100%;width:100%;";
        document.querySelector("#gameContainer").append(fullScreenElement);

        const doc = window.document;
        const docEl = doc.documentElement;
        const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;


        if (!doc.fullscreenElement && !this.fullScreenOnce) {
            fullScreenElement.addEventListener("touchend", toggleFullScreen)
            // if (screen && screen.orientation) {
            //     screen.orientation.addEventListener('change', toggleFullScreen)
            // }
        }

        function toggleFullScreen() {
            event.stopPropagation();
            if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                this.fullScreenOnce = true;
                requestFullScreen.call(docEl);
                fullScreenElement.removeEventListener('touchend', toggleFullScreen);
                // screen.orientation.removeEventListener('change', toggleFullScreen);
                fullScreenElement.remove();
            }
        }
    }

    changeOrientationCss() {
        document.getElementsByTagName("html")[0].style.height = "100vh";

        if (document.getElementById("gameContainer")) {
            document.getElementById("gameContainer").style.position = "fixed";
            document.getElementById("gameContainer").style.top = "0";
            document.getElementById("gameContainer").style.bottom = "0";
        }
    }
}
